/**
 * @generated SignedSource<<e133cc68dad6e39ea120df401c48f9f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type queueFragment_EnqueueMutation$variables = {
  kind: string;
  params?: any | null | undefined;
  retryJobId?: number | null | undefined;
};
export type queueFragment_EnqueueMutation$data = {
  readonly accountJobEnqueue: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly job: {
      readonly jobId: number;
      readonly status: string;
    } | null | undefined;
    readonly outcome: string;
    readonly superseded: ReadonlyArray<number>;
  } | null | undefined;
};
export type queueFragment_EnqueueMutation = {
  response: queueFragment_EnqueueMutation$data;
  variables: queueFragment_EnqueueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "kind"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "params"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "retryJobId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "kind",
    "variableName": "kind"
  },
  {
    "kind": "Variable",
    "name": "params",
    "variableName": "params"
  },
  {
    "kind": "Variable",
    "name": "retryJobId",
    "variableName": "retryJobId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outcome",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "superseded",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountJob",
  "kind": "LinkedField",
  "name": "job",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "queueFragment_EnqueueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountJobEnqueueMutationPayload",
        "kind": "LinkedField",
        "name": "accountJobEnqueue",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queueFragment_EnqueueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountJobEnqueueMutationPayload",
        "kind": "LinkedField",
        "name": "accountJobEnqueue",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "620ec6c1831715c0362e88bcaa1e550e",
    "id": null,
    "metadata": {},
    "name": "queueFragment_EnqueueMutation",
    "operationKind": "mutation",
    "text": "mutation queueFragment_EnqueueMutation(\n  $kind: String!\n  $params: JSON\n  $retryJobId: Int\n) {\n  accountJobEnqueue(kind: $kind, params: $params, retryJobId: $retryJobId) {\n    outcome\n    superseded\n    job {\n      jobId\n      status\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "74962665aefc146839edfea7cdc4bdc1";

export default node;
